const goodsCommon = {
  methods: {
    // 商品价格 排序处理
    filterPrice(list,ids = null) {
      if (list.length) {
        let result = []; 
        list.map(item => {
          item.price = item.isFree == 1 ? 0 : item.price;
          if (item.price instanceof Number) {
            item.price = item.price.toFixed(2);
          }
        })
        // 如果传入ids进行排序
        if (ids !== null) {
          list.forEach((a) => {
            result[ids.indexOf(a.goodsId)] = a;
          });
          list = result;
          console.log(ids,list,'排序后数组')
        }
      }
      return list
    },
    // 商品详情跳转
    openH5GoodsDetail(data) {
      let path = '/goodsDetail';
      let query = {
        goodsId: data.goodsId,
        goodsKind: data.goodsKind, //1 普通商品 2 分销商品 3 实物商品
      }
      if (data.goodsKind == '1') {
        path = '/goodsDetail';
        query.backName = this.$route.path;
      } else if (data.goodsKind == '2') {
        path = '/goodsDetail';
        query.isH5 = 1
      } else {
        path = '/entityGoodsDetail';
        query.visit_referrer = 'goods_list';
        query.branchId = this.branchId;
      }
      this.$router.push({
        path: path,
        query: query
      })
    }
  }
}
export default goodsCommon